// extracted by mini-css-extract-plugin
export var attachment = "_j6-a";
export var emailContainer = "_j6-4";
export var emailContentPaddedContainer = "_j6-b";
export var emailHeader = "_j6-6";
export var emailIframe = "_j6-3";
export var emailInfoIcon = "_j6-9";
export var emailShortenedSummary = "_j6-e";
export var infoDropdown = "_j6-0";
export var infoRowBoundedContent = "_j6-d";
export var internal = "_j6-5";
export var merchant = "_j6-8";
export var messageInputContainer = "_j6-h";
export var normal = "_j6-7";
export var replyCard = "_j6-f";
export var subtleButton = "_j6-1";
export var subtleButtonIconContainer = "_j6-2";
export var toggleViewRepliesButton = "_j6-c";
export var wrappingText = "_j6-g";